// Pagination
const defaultPageNo=1;
const defaultPageSize = 10;
const defaultDebounceMs = 300;
const onlinePaymentsTableHeight = 'calc(100vh - 436px)';
const onlinePaymentsTableHeightWithoutTopCards = 'calc(100vh - 298px)'
export {
  defaultPageNo,
  defaultPageSize,
  onlinePaymentsTableHeight,
  onlinePaymentsTableHeightWithoutTopCards,
  defaultDebounceMs
};
